<template>
    <div class="company-news-container">
        <div class="mobile-title">焱图动态</div>
        <div class="news-block-wrap">
            <div class="block" @click="toDetail(item.id)" v-for="(item, index) in newsList" :key="index">
                <div class="block-top">
                    <img :src="item.imgUrl" alt="">
                </div>
                <div class="block-bottom">
                    <div class="date">{{ item.createTime }}</div>
                    <div class="title">{{ item.newsTitle }}</div>

                    <i class="el-icon-right"></i>
                </div>
            </div>
        </div>
        <div class="more-button" v-if="moreFlag" @click="getList(9, pageNum + 1)"><span>加载更多</span><i
                class="el-icon-arrow-down"></i></div>
    </div>
</template>

<script>
import { getNewsList } from "../../util/api.js";

export default {
    data() {
        return {
            newsList: [],
            pageSize: 9,
            pageNum: 1,
            totalCount: 0
        }
    },
    computed: {
        moreFlag() {
            return this.newsList.length < this.totalCount;
        }
    },

    created() {
        this.getList(9, 1)
    },
    methods: {
        // 获取新闻列表
        getList(pageSize, pageNum) {
            this.pageSize = pageSize
            this.pageNum = pageNum
            getNewsList(pageSize, pageNum).then(res => {
                if (res.data.status == 'success') {
                    res.data.data.newsList.map(item => {
                        item.imgUrl = this.extractFirstImageUrl(item.newsContent)
                        item.createTime = this.formatDate(item.createTime)
                        item.iconFlag = false
                    })
                    this.newsList = this.newsList.concat(res.data.data.newsList); // 合并新获取的新闻
                    this.totalCount = res.data.data.total;
                }
            })
        },
        formatDate(isoDateString) {
            const date = new Date(isoDateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要 +1
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        // 获取第一张图片的url
        extractFirstImageUrl(htmlString) {
            const imgRegex = /<img.*?src="(.*?)"/;
            const match = htmlString.match(imgRegex);
            if (match && match[1]) {
                return match[1];
            } else {
                return ''
            }
        },

        toDetail(id) {
            this.$router.push({
                name: "news-detail",
                params: {
                    id: id,
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
.company-news-container {
    max-width:var(--main-width);
    width:84%;
    margin:3.68rem auto 10.43rem;
    .mobile-title {
        display:none;
    }
    .news-block-wrap {
        display: grid;
        grid-template-columns: repeat(3, 1fr); /* 每行三列 */
        gap:2.875rem;
        .block {
            // flex: 1 1 30%;
            max-width:22.96rem;
            min-width:20.75rem;
            transition:all 0.2s;
            cursor:pointer;
            background-color:#fff;
            margin-bottom: 2.7rem;
            .block-top {
                height:15.5rem;
                overflow:hidden;
                img {
                    width:100%;
                    height:100%;
                    display:block;
                    object-fit:cover;
                    object-position:center;
                }
            }
            .block-bottom {
                padding:0.875rem 0 1rem 1.56rem;
                height:8rem;
                position:relative;

                .date {
                    color:#999999;
                    margin-bottom:18px;
                }
                .title {
                    color:#333333;
                    font-size:1.3rem;
                    font-weight:bold;
                }
                /deep/.el-icon-right {
                font-size:25px;
                position:absolute;
                right:25px;
                bottom:15px;
                display:none;
                color:#2372E9;
            }
            }
            .block-bottom:hover {
                /deep/.el-icon-right {
                    display:block !important;
                }
            }
          
        }
        .block:hover {
            transform:translateY(-22px);
            box-shadow: 0px 4px 30px 0px rgba(0,0,0,0.08);
            .title {
                color:#2372E9;
            }
        }
        .title {

        }
    }
    .more-button {
        cursor:pointer; 
        width:8.75rem;
        margin:4.25rem auto 10.43rem;
        height:3.125rem;
        line-height:3.125rem;
        display:flex;
        align-items:center;
        border-radius: 6px 6px 6px 6px;
        justify-content:center;
        border: 1px solid #333333;
        span  {
            margin-right:7px;
         
        }
        /deep/.el-icon-arrow-down {
                color:#888888;
                font-size:22px;
            }
    }
   
            .more-button:hover {
                background-color:#2372E9;
                color:#fff;
                border:1px solid #2372E9;
                /deep/.el-icon-arrow-down {
                    color:#fff;
                }
            }
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {

}
@media only screen and (max-width: 768px) {
    .about-container {
        
    }
    .mobile-title {
        text-align:center;
        font-size:22px;
        display:block !important;
        margin-bottom:31px;
        position:relative;
        font-weight:bold;
    }
    .news-block-wrap {
        display:flex !important;
        gap:0 !important;
        flex-wrap:wrap;
        .block {
            width:90% !important;
            max-width:30rem !important;
            margin-bottom: 20px !important;
            margin: 0 auto;
            .title {
                font-size:18px !important;
            }
        }
        .block-top { 
           height:232px !important;
        }
    }
    .company-news-container {
        width:auto !important;
        padding-top:27px;
        margin:auto 0 !important;
        background-color:#F6F7F9 !important;
    }
    .more-button {
        margin:20px auto 47px !important;
        width:102px !important;
        height:32px !important;
        font-size:14px;
    }
    .block-bottom {
        padding:15px !important;
    }
}

</style>
